import { SVGProps } from 'react';

const TripsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.7122 1.83577C19.3173 2.46999 19.3173 3.4912 18.7122 4.11467L14.7224 8.29624L16.8968 18.1751L15.4506 19.7015L11.4711 11.7146L7.47114 15.9069L7.84037 18.562L6.74294 19.7015L4.93781 16.2831L1.66602 14.3805L2.7532 13.2195L5.3173 13.6173L9.28653 9.45719L1.66602 5.25412L3.12243 3.73844L12.5481 6.01734L16.5378 1.83577C17.1122 1.2123 18.1378 1.2123 18.7122 1.83577Z"
      fill="currentColor"
    />
  </svg>
);
export default TripsIcon;
